import { render, staticRenderFns } from "./SpecUpdate.vue?vue&type=template&id=9bc1fada"
import script from "./SpecUpdate.vue?vue&type=script&lang=js"
export * from "./SpecUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports